import Moment from 'moment';

export function isOldCompany(company) {
	// old company
	const createdAt = Moment(company?.createdAt, 'x');
	const transitionDay = Moment('2021-03-24'); // from this day people can choose a custom color in the project settings
	return createdAt.isBefore(transitionDay);
}